import {connect} from 'react-redux';
import {getTogglesStatus} from 'common/storeUtils';
import {ToggleGate} from 'app-ui-componentlibrary/dist/componentLibrary/conditionGates/ToggleGate';

export const mapStateToProps = (state) => {
  return {
    toggleStatus: getTogglesStatus(state),
  };
};

const ConnectedToggleGate = connect(mapStateToProps)(ToggleGate);

export default ConnectedToggleGate;
